import { render, staticRenderFns } from "./SizeChartView.vue?vue&type=template&id=415a0092&scoped=true"
import script from "./SizeChartView.vue?vue&type=script&lang=js"
export * from "./SizeChartView.vue?vue&type=script&lang=js"
import style0 from "./SizeChartView.vue?vue&type=style&index=0&id=415a0092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415a0092",
  null
  
)

export default component.exports